import SystemModal from "../Common/SystemModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import ajaxStationsGroups from "../../util/remote/ajaxStationsGroups";
const UpdateStationModal = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // Form fields
  const [group_name, setgroup_name] = useState("");
  // Populate form when modal opens
  useEffect(() => {
    if (props.data) {
      var data = props.data;
      setgroup_name(data.group_name || "");
    }
  }, [props.data]);
  const allRowsFilled = () => group_name;
  const handleUpdate = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const payload = {
      id: props.data.id,
      group_name: group_name,
    };
    setLoading(true);
    const response = await ajaxStationsGroups.update_stations_groups(payload);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func();
      setTimeout(() => {
        closeModal();
      }, 2000);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleUpdate(e, controls.close)}
        disabled={loading}
      >
        {loading ? "Updating..." : "Update "}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Update Fuel Station Group"
      size="md"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <form>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label>
                        Group Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={group_name}
                        onChange={(e) => setgroup_name(e.target.value)}
                        className="form-control"
                        placeholder="Enter farm name"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default UpdateStationModal;
